// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"block-header_wrapper__Lsr3y"};